export default __webpack_public_path__ + "static/media/importsPage3Light.8a2a937a.png";